import type { CSSProperties } from "react";
import { useState } from "react";

export function useHover(
  styleOnHover: CSSProperties,
  styleOnNotHover: CSSProperties = {},
) {
  const [isHovered, setIsHovered] = useState(false);

  const hoverProps = {
    onPointerEnter: () => setIsHovered(true),
    onPointerLeave: () => {
      setIsHovered(false);
    },
    onTouchStart: () => setIsHovered(true),
    onTouchEnd: () => setIsHovered(false),
  };

  const style = isHovered ? styleOnHover : styleOnNotHover;

  return {
    hoverProps,
    style,
  };
}
